import kilabColors from '../../assets/scss/zsw_colors.module.scss';
import kilabLogo  from "!file-loader!../../assets/img/kilab_logo.svg"

const kilabTheme = {
    institutionName: "KiLab",
    abbreviation: "KILAB",
    colors: kilabColors,
    logo: kilabLogo,
    impressum: "",
    dataProtection: "https://www.zsw-bw.de/footer/datenschutz.html"
}

export default kilabTheme